module.exports = __webpack_public_path__ + "img/ky5.3a157f45.png";